//import User from './data/User-123.json';

import authService from '@/services/authService';
import commonService from '@/services/commonService';
import HttpFactory from '@/mixins/http.factory';
import Modal from '@/components/modal/modal.vue';
import TwoFactorAuthCheck from '@/components/two-factor-auth-check/two-factor-auth-check.vue';
export default {
	name:'login',
	mixins:[HttpFactory],
	data () {
		return {
			email:'',
			password:'',
			otpToken:'',
			codeData:null,
			show2FactorSetupPop:false,
			showOtpForm:false,
			redirectUrl:'/'
		};
	},
	watch: {
		showOtpForm: function () {
			const _self=this;
			if (_self.showOtpForm){
				//setTimeout(function(){_self.$refs.otpForm.otpToken.focus()},200);
			}
		}
	},
	created(){
		//this.init();
	},
	methods:{
		init(){
			let redirectUriQuery=commonService.getParameterByName('redirect').trim();
			this.redirectUrl=(redirectUriQuery && redirectUriQuery!='')?redirectUriQuery:'/';
		},
		isChromeBrowser(){
			let isChromeBrowser=false;
			if(navigator.userAgent.indexOf("Opera")!=-1 || navigator.userAgent.indexOf('OPR') != -1 ){
				isChromeBrowser=false;
			}
			else if(navigator.userAgent.indexOf("Edge") != -1 ) {
				isChromeBrowser=false;
			}
			else if(navigator.userAgent.indexOf("Chrome") != -1 ){
				isChromeBrowser=true;
			}else if(navigator.userAgent.indexOf("Safari") != -1){
				isChromeBrowser=false;
			}
			else if(navigator.userAgent.indexOf("Firefox") != -1 ) {
				isChromeBrowser=false;
			}
			else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )){
				isChromeBrowser=false;
			}
			else{
				isChromeBrowser=false;
			}
			return isChromeBrowser;
		},
		async authenticateUser(){
			let _self=this;
			let data={
				email:_self.email,
				password:_self.password
			};
			_self.responseData=null;
			_self.fn().clearMessage();
			try{
				let response =await _self.post('auth/login',data);
				if(response && response.data && response.data.Success){
					if(response.data.User.enableTFA && response.data.User.TFASetup){
						_self.showOtpForm=true;
					}else{
						let access_token=response.data.AuthResponse.Token;
						authService.setAccessToken(access_token,true);
						authService.setAuthResponse(JSON.stringify(response.data),true);
						let redirectPath='/';
						if(response.data.User.userRoles && response.data.User.userRoles.length>0){
							redirectPath=response.data.User.userRoles[0].redirectPath?response.data.User.userRoles[0].redirectPath:redirectPath;
						}
						redirectPath='/admin/devops-customers';//temp
						_self.redirectUrl=redirectPath;
						if(response.data.User.enableTFA && !response.data.User.TFASetup){
							//localStorage["authCred"]=JSON.stringify(data);
							//_self.$router.push(`/two-factor-login-check`);
							_self.responseData=response;
							_self.show2FactorSetupPop=true
						}else{
							_self.userMsg.type='info';
							_self.userMsg.list=['Authenticated redirecting....'];
							_self.$router.push(redirectPath);	
						}
					}
					//document.location.href=redirectPath;
				}else{
					_self.userMsg.list=['Invalid credentials'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
		},
		async authenticateOtp(){
			let _self=this;
			let data={
				email:_self.email,
				password:_self.password,
				otp:_self.otpToken
			};
			_self.fn().clearMessage();
			try{
				let response=await _self.post('auth/login',data)
				_self.loading=false;
				if(response && response.data && response.data.Success){
					let access_token=response.data.AuthResponse.Token;
						authService.setAccessToken(access_token,true);
						authService.setAuthResponse(JSON.stringify(response.data),true);
						let redirectPath='/';
						if(response.data.User.userRoles && response.data.User.userRoles.length>0){
							redirectPath=response.data.User.userRoles[0].redirectPath?response.data.User.userRoles[0].redirectPath:redirectPath;
						}
						redirectPath='/admin/devops-customers';//temp
						_self.redirectUrl=redirectPath;
						_self.userMsg.type='info';
						_self.userMsg.list=['Authenticated redirecting....'];
						_self.$router.push(redirectPath);	
				}
				else{
					_self.userMsg.list=['Invalid token'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
			
		},
		skip2FactorEnable(){
			const _self=this;
			_self.$router.push(_self.redirectUrl);
		},
		hide2FactorSetupPop(){
			const _self=this;
			_self.show2FactorSetupPop=false;
			_self.skip2FactorEnable();
		},
		hideOtpFormPop(){
			const _self=this;
			_self.showOtpForm=false;
		},		
	},
	components:{
		Modal,TwoFactorAuthCheck
	}
}